import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer-copyright">
        Copyright © Kugathaj Kangeswaran. 
      </p>
    </footer>
  );
}

export default Footer;